import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { Input, Button } from '@oc-labs/wt-storybook';
import ModalV2 from '../../ModalV2';
import useModal from '../../../hooks/useModal';

const MODAL_NAME = 'translation-upsert-translation';

export default function UpsertTranslationModal({ translationAdmin }) {
  const { close, data } = useModal(MODAL_NAME);
  const [isEditing, setIsEditing] = useState(false);
  const [translation, setTranslation] = useState({
    termId: '',
    languageId: '',
    termCode: '',
    languageCode: '',
    translation: '',
  });

  useEffect(() => {
    if (!data) {
      setTranslation({ termId: '', languageId: '', termCode: '', languageCode: '', translation: '' });
      setIsEditing(false);
      return;
    }

    const incomingTranslation = data?.translation ?? '';
    const languageId = data?.languageId ?? data?.language?.id ?? data?.language?.code ?? null;
    const termId = data?.termId ?? data?.term?.id ?? data?.term?.code ?? null;
    const languageCode = data?.language?.code ?? (typeof data?.languageId === 'string' ? data?.languageId : '') ?? '';
    const termCode = data?.term?.code ?? data?.term?.term ?? (typeof data?.termId === 'string' ? data?.termId : '') ?? '';

    if (!languageId) {
      toast.error('Please select a language first');
      close();
      return;
    }
    if (!termId) {
      toast.error('Please select a term first');
      close();
      return;
    }

    setTranslation({ translation: incomingTranslation, languageId, termId, languageCode, termCode });
    setIsEditing(Boolean(incomingTranslation));
  }, [data]);

  const handleConfirm = async () => {
    await translationAdmin.upsertTranslation(translation);
    close();
    toast.success('Term added successfully');
  };

  return (
    <ModalV2 name={MODAL_NAME} title="Upsert Translation" className="w-full max-w-md">
      <div className="space-y-6">
        <div className="space-y-4">
          <Input
            label="Translation"
            value={translation?.translation}
            onChange={(e) =>
              setTranslation({ ...translation, translation: e.target.value })
            }
            placeholder="Enter translation"
            type="text"
          />
        </div>

        <div className="flex gap-4 pt-2">
          <Button type="tertiary" className="w-1/2" onClick={close}>
            Cancel
          </Button>

          <Button type="primary" className="w-1/2" onClick={handleConfirm}>
            Confirm
          </Button>
        </div>
      </div>
    </ModalV2>
  );
}
